export const columnsDataDevelopment = [
  {
    Header: "STATEMENT",
    accessor: "STATEMENT",
  },
  {
    Header: "BUGS",
    accessor: "BUGS",
  },
  {
    Header: "WEBSITE",
    accessor: "WEBSITE",
  },
  {
    Header: "SERVER",
    accessor: "SERVER",
  },
  
];

export const columnsDataCheck = [
  {
    Header: "STATEMENT",
    accessor: "STATEMENT",
  },
  {
    Header: " BUGS",
    accessor: " BUGS",
  },
  {
    Header: "WEBSITE",
    accessor: "WEBSITE",
  },
  {
    Header: "SERVER",
    accessor: "SERVER",
  },
];

export const columnsDataColumns = [
  {
    Header: "STATEMENT",
    accessor: "STATEMENT",
  },
  {
    Header: " BUGS",
    accessor: " BUGS",
  },
  {
    Header: "WEBSITE",
    accessor: "WEBSITE",
  },
  {
    Header: "SERVER",
    accessor: "SERVER",
  },
];

export const columnsDataComplex = [
  {
    Header: "STATEMENT",
    accessor: "STATEMENT",
  },
  {
    Header: "BUGS",
    accessor: "BUGS",
  },
  {
    Header: "WEBSITE",
    accessor: "WEBSITE",
  },
  {
    Header: "SERVER",
    accessor: "SERVER",
  },
];
